let Public = {
  verifyId(rule, val, callback) {
    if (!val) {
      callback();
      return;
    }
    const reg = /^[A-Za-z0-9]+$/;
    if (!reg.test(val)) {
      callback("只能是字母或数字，请修改");
      return;
    }
    if (val && val.length !== 32) {
      callback("id长度应为32位");
      return;
    }
    callback();
  }
};
//判断字符是否为空的方法
export function isEmpty(obj) {
  if (typeof obj == "undefined" || obj == null || obj == "") {
    return true;
  } else {
    return false;
  }
}
// 判断行政区级别
export function judgeAreaLevel(areaCd) {
  if (areaCd.length === 6) {
    if (areaCd.replace(/(0+)$/g, "").length === 4) {
      return "市";
    } else {
      return "区县";
    }
  }
  if (areaCd.length === 9) {
    return "乡镇";
  }
  if (areaCd.length === 12) {
    return "村居";
  }
}
export default Public;
